
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapestcabserviceinpune() {



    const cardData =
    {
        keyword: 'Cheapest Cab Service in Pune',
        heading: 'Platinum24 Cabs: Cheapest Cab Service in Pune',
        headingDescription: ' Platinum24 Cabs provides the Cheapest Cab Service in Pune without compromising on comfort, safety, or reliability. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures affordable travel options for city rides, airport transfers, corporate trips, and outstation journeys. With transparent pricing, no hidden charges, and flexible booking options, we make travel budget-friendly for individuals, families, and groups. Whether it’s a quick local ride or a long-distance trip, Platinum24 Cabs guarantees clean vehicles, professional chauffeurs, and dependable service at the lowest fares in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description": "Kaas Plateau, a UNESCO World Natural Heritage Site near Satara, is famous for its seasonal bloom of wildflowers. From August to October, the plateau turns into a colorful carpet of orchids, lilies, and rare species. Nature lovers and photographers flock here for its breathtaking landscapes. The site is carefully protected, ensuring eco-friendly tourism. Misty monsoons make it even more enchanting. Kaas Plateau is Satara’s crown jewel of natural beauty."
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "Ajinkyatara Fort, perched at 3,300 feet, offers panoramic views of Satara city. Built in the 16th century, it played a strategic role in Maratha history. The fort has bastions, gates, and temples like Hanuman and Devi shrines. Trekking up is moderately easy and rewarding with scenic vistas. It is especially popular during monsoon. Ajinkyatara Fort is Satara’s living reminder of Maratha valor."
  },
  {
    "title": "Thoseghar Waterfall",
    "description": "Thoseghar Waterfall near Satara is a breathtaking cascade that plunges from over 1,000 feet. Surrounded by lush green hills, it is one of Maharashtra’s tallest waterfalls. Monsoon transforms it into a thundering natural wonder. Visitors enjoy viewpoints and picnic spots nearby. Photographers capture its majestic flow and misty ambiance. Thoseghar is Satara’s monsoon paradise."
  },
  {
    "title": "Sajjangad Fort",
    "description": "Sajjangad Fort is a revered spiritual site, known as the final resting place of Sant Ramdas, spiritual guide of Chhatrapati Shivaji Maharaj. Pilgrims visit for its temples and ashrams, where bhajans and prayers create a divine aura. The fort also offers scenic views of valleys and lakes. Devotees believe visiting here grants peace and blessings. Sajjangad is Satara’s sacred blend of history and spirituality."
  },
  {
    "title": "Koyna Dam & Wildlife Sanctuary",
    "description": "Koyna Dam, built on the Koyna River, is one of India’s largest hydroelectric projects. Surrounded by the Western Ghats, it creates the beautiful Shivsagar Lake. The nearby Koyna Wildlife Sanctuary is home to tigers, leopards, and diverse flora and fauna. Monsoon enhances the greenery and water levels, making it a scenic retreat. Boating and nature walks are popular here. Koyna is Satara’s powerhouse of beauty and energy."
  },
  {
    "title": "Natraj Mandir, Satara",
    "description": "Natraj Mandir in Satara is a unique temple dedicated to Lord Shiva in the form of Nataraja, inspired by the famous Chidambaram temple of Tamil Nadu. Its Dravidian-style architecture and intricate carvings attract devotees and tourists. The temple is serene and spiritually uplifting. Festivals like Mahashivratri draw large crowds. Surrounded by peaceful ambiance, it is ideal for meditation. Natraj Mandir is Satara’s sacred cultural landmark."
  },
  {
    "title": "Kaas Lake",
    "description": "Kaas Lake, located near the famous Kaas Plateau, is a tranquil water body surrounded by greenery. It was originally built as a reservoir for Satara. The calm environment makes it ideal for relaxation and photography. Migratory birds can be spotted during certain seasons. Tourists often combine a visit with the flower valley. Kaas Lake is Satara’s peaceful natural retreat."
  },
  {
    "title": "Chalkewadi Windmill Farms",
    "description": "Chalkewadi Windmill Farms, near Thoseghar, feature hundreds of giant windmills dotting the hills. It is one of Maharashtra’s largest wind energy projects. The landscape looks surreal, especially during monsoon with mist and waterfalls around. Tourists enjoy scenic drives and photography here. The site is peaceful yet futuristic in appeal. Chalkewadi is Satara’s blend of green energy and natural charm."
  },
  {
    "title": "Jarandeshwar Temple & Caves",
    "description": "Jarandeshwar Temple near Satara is dedicated to Lord Shiva and is located near ancient Buddhist caves. The caves have rock-cut architecture and historical significance. Pilgrims visit the temple for its divine aura and natural setting. The site is surrounded by forests and hills, making it serene. It attracts both history lovers and devotees. Jarandeshwar is Satara’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Yamai Devi Temple, Aundh",
    "description": "Located near Satara, the Yamai Devi Temple at Aundh is an ancient and highly revered shrine. Dedicated to Goddess Yamai, it is an important pilgrimage site in Maharashtra. Devotees climb steps to reach the temple perched on a hilltop. The temple is especially vibrant during Navratri. It also offers panoramic views of the surrounding landscape. Yamai Devi Temple is Satara’s divine abode of faith and devotion."
  }
],



    "services": [
    {
      "name": "Cheap Cab Service Pune",
      "description": "Our Cheap Cab Service in Pune is designed to provide budget-friendly rides without compromising on quality and comfort. Whether you need a quick local commute or a longer outstation journey, our affordable cabs ensure you travel safely and punctually while keeping your expenses low. Enjoy hassle-free booking, reliable vehicles, and professional drivers at prices that suit your wallet."
    },
    {
      "name": "Affordable Taxi Pune",
      "description": "Affordable Taxi Pune offers cost-effective transportation solutions tailored to meet the needs of daily commuters, tourists, and corporate travelers. Our well-maintained fleet and courteous drivers make sure you receive timely service with transparent pricing and no hidden charges. Ideal for those who seek value without sacrificing reliability."
    },
    {
      "name": "Budget Cab Service Pune",
      "description": "Our Budget Cab Service in Pune caters to passengers looking for economical travel options. Perfect for students, families, and business travelers, this service provides comfortable rides at competitive rates. We prioritize safety, cleanliness, and punctuality, ensuring you get the best service on a budget."
    },
    {
      "name": "Pune Cheapest Taxi Booking",
      "description": "Book Pune’s Cheapest Taxi with us and enjoy the lowest fare options available in the city. Our online booking platform is user-friendly and provides instant fare estimates, allowing you to plan your travel budget efficiently. Despite the low costs, we maintain high standards of service, making sure you get the best value for money."
    },
    {
      "name": "Low Fare Cab Pune",
      "description": "Travel smart with our Low Fare Cab Pune service, which combines affordability with dependable transport. Ideal for local trips or longer rides, our low fare cabs are driven by experienced chauffeurs who ensure safe and timely journeys at prices that won’t break the bank."
    },
    {
      "name": "Pune Cheap Taxi Service",
      "description": "Pune Cheap Taxi Service offers economical rides for daily and occasional travelers alike. Our fleet includes a variety of cars to suit different group sizes, all maintained to ensure comfort and safety. With easy booking options and flexible cancellation policies, our cheap taxi service is both convenient and budget-friendly."
    },
    {
      "name": "Discounted Cab Service Pune",
      "description": "Take advantage of our Discounted Cab Service in Pune, where regular offers and promotional deals make your rides even more affordable. Perfect for frequent travelers and those planning longer trips, this service ensures that you get quality rides with attractive discounts and special packages."
    },
    {
      "name": "Pune Affordable Taxi with Driver",
      "description": "Our Pune Affordable Taxi with Driver service provides you with professional chauffeurs who know the city inside out, ensuring smooth and timely travel. This service combines the benefits of personal assistance with budget-friendly fares, ideal for those who prefer a dedicated driver for comfort and convenience."
    },
    {
      "name": "Pune Cheap Cab Deals",
      "description": "Explore exclusive Pune Cheap Cab Deals that make your travels even more economical. We offer seasonal discounts, group booking offers, and corporate packages, giving you more reasons to choose our budget-friendly taxi services for all your transportation needs."
    },
    {
      "name": "Cheapest Taxi Rates Pune",
      "description": "Benefit from the Cheapest Taxi Rates in Pune with our transparent and upfront pricing system. No hidden charges or surge pricing—just affordable, fixed-rate rides that let you travel stress-free within the city and to nearby destinations."
    },
    {
      "name": "Pune Budget Taxi Service",
      "description": "Our Pune Budget Taxi Service is designed to meet the requirements of cost-conscious travelers. Whether for daily commuting or special occasions, we provide safe, clean, and reliable taxis at pocket-friendly prices, ensuring you get the best service without overspending."
    },
    {
      "name": "Pune Cheap Local Cab",
      "description": "Choose Pune Cheap Local Cab service for quick and affordable intra-city travel. Our local cabs are perfect for short trips to office, markets, or social gatherings, offering convenience, speed, and low fares to make your daily commute hassle-free."
    },
    {
      "name": "Affordable Airport Taxi Pune",
      "description": "Travel to and from Pune Airport with our Affordable Airport Taxi service that combines low rates with punctuality and comfort. Our drivers track your flight timings and provide timely pickups and drop-offs, ensuring you never miss a flight or wait unnecessarily."
    },
    {
      "name": "Pune Cheap Outstation Taxi",
      "description": "Planning a trip outside Pune? Our Pune Cheap Outstation Taxi service offers budget-friendly long-distance travel options with comfortable vehicles and reliable drivers. Ideal for family trips, business travel, or weekend getaways, this service guarantees safe journeys at affordable rates."
    },
    {
      "name": "Pune Low Cost Taxi Service",
      "description": "Our Pune Low Cost Taxi Service focuses on providing economical rides for all your transportation needs. Whether it’s a quick local trip or an extended journey, our taxis come with fixed low rates, well-maintained vehicles, and courteous drivers ensuring a pleasant and affordable travel experience."
    }
  ],
  "tableData": [
    ["Cheap Cab Service Pune", "Affordable Taxi Pune"],
    ["Budget Cab Service Pune", "Pune Cheapest Taxi Booking"],
    ["Low Fare Cab Pune", "Pune Cheap Taxi Service"],
    ["Discounted Cab Service Pune", "Pune Affordable Taxi with Driver"],
    ["Pune Cheap Cab Deals", "Cheapest Taxi Rates Pune"],
    ["Pune Budget Taxi Service", "Pune Cheap Local Cab"],
    ["Affordable Airport Taxi Pune", "Pune Cheap Outstation Taxi"],
    ["Pune Low Cost Taxi Service", "—"]
  ],


          "whychoose": [
    {
      "WhyChooseheading": "Affordable and Cheapest Cab Service in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers the most budget-friendly cab services in Pune without compromising on quality."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront and fair pricing that includes fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "Wide Range of Economical Vehicle Options",
      "WhyChoosedescription": "Choose from cost-effective hatchbacks and sedans suitable for solo travelers and small groups."
    },
    {
      "WhyChooseheading": "Quick and Easy Online Booking",
      "WhyChoosedescription": "Book your cheapest cab in Pune within minutes using our website or app."
    },
    {
      "WhyChooseheading": "Reliable Service with Experienced Drivers",
      "WhyChoosedescription": "Our professional drivers ensure safe and timely rides, even at economical rates."
    },
    {
      "WhyChooseheading": "Clean and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel comfortably in sanitized cabs that meet high standards of hygiene and safety."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Assistance",
      "WhyChoosedescription": "Our support team is available round the clock to help you with bookings and queries."
    },
    {
      "WhyChooseheading": "Flexible Booking for Local and Outstation Trips",
      "WhyChoosedescription": "Enjoy budget-friendly rates for both short city rides and longer journeys from Pune."
    }
  ]





































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer the cheapest cab service in Pune?',
        answer: 'Yes, Platinum24 Cabs provides affordable and competitively priced cab services in Pune without compromising on quality and comfort.',
    },
    {
        question: 'How can I book the cheapest cab service in Pune with Platinum24 Cabs?',
        answer: 'You can book the most economical cab options through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of budget-friendly vehicles are available in Pune?',
        answer: 'We offer a variety of cost-effective vehicles including hatchbacks, sedans, and shared cabs to suit different budgets.',
    },
    {
        question: 'Are there any hidden charges in the cheapest cab service fares?',
        answer: 'No, our pricing is transparent with no hidden charges. All fares include vehicle charges, driver allowance, fuel, tolls, and taxes.',
    },
    {
        question: 'Can I get discounts or offers on cab services in Pune?',
        answer: 'Yes, we frequently provide special discounts and promotional offers. Check our website or app for the latest deals.',
    },
    {
        question: 'Is the cheapest cab service reliable and safe?',
        answer: 'Absolutely. Even our budget-friendly cabs maintain high standards of safety, hygiene, and professionalism.',
    },
    {
        question: 'Can I book the cheapest cab for local and outstation trips from Pune?',
        answer: 'Yes, our affordable cabs are available for both local rides and outstation trips from Pune.',
    },
    {
        question: 'How do you ensure quality service at affordable rates?',
        answer: 'We optimize our fleet and operational efficiency to provide you the best service at competitive prices.',
    },
    {
        question: 'Can I customize my ride while opting for the cheapest cab service?',
        answer: 'Yes, you can choose pickup/drop locations and trip duration as per your needs within the affordable options.',
    },
    {
        question: 'Does Platinum24 Cabs offer corporate packages for budget travel in Pune?',
        answer: 'Yes, we provide customized corporate travel solutions that are both economical and efficient.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Patil',
        feedback: 'Platinum24 Cabs offers the most affordable and reliable cab service in Pune. Great value for money!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sheetal Kulkarni',
        feedback: 'I was surprised by the budget-friendly prices without any compromise on service quality. Highly recommended.',
        rating: 5,
    },
];




















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const cheapestCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Offering the cheapest and most affordable cab service in Pune with budget-friendly taxi booking, low fares, and reliable rides.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Cheap Cab Service Pune",
    "Affordable Taxi Pune",
    "Budget Cab Service Pune",
    "Pune Cheapest Taxi Booking",
    "Low Fare Cab Pune",
    "Pune Cheap Taxi Service",
    "Discounted Cab Service Pune",
    "Pune Affordable Taxi with Driver",
    "Pune Cheap Cab Deals",
    "Cheapest Taxi Rates Pune",
    "Pune Budget Taxi Service",
    "Pune Cheap Local Cab",
    "Affordable Airport Taxi Pune",
    "Pune Cheap Outstation Taxi",
    "Pune Low Cost Taxi Service"
  ],
  "telephone": "+91-XXXXXXXXXX",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Affordable Taxi Services Pune",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Budget Taxi Service Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Affordable Airport Taxi Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Cheap Outstation Taxi Pune"
        }
      }
    ]
  }
};





    return (
        <div>
<Helmet>
  <title>Cheapest Cab Service in Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Offering the cheapest and most affordable cab service in Pune with budget-friendly taxi booking, low fares, and reliable rides."
  />
  <meta
    name="keywords"
    content="Cheap Cab Service Pune, Affordable Taxi Pune, Budget Cab Service Pune, Pune Cheapest Taxi Booking, Low Fare Cab Pune, Pune Cheap Taxi Service, Discounted Cab Service Pune, Pune Affordable Taxi with Driver, Pune Cheap Cab Deals, Cheapest Taxi Rates Pune, Pune Budget Taxi Service, Pune Cheap Local Cab, Affordable Airport Taxi Pune, Pune Cheap Outstation Taxi, Pune Low Cost Taxi Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(cheapestCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cheapestcabserviceinpune;